'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIList from 'UIComponents/list/UIList';
import { EERIE } from 'HubStyleTokens/colors';
import ToolbarDropdownButton from '../toolbar/ToolbarDropdownButton';
import styled from 'styled-components';
import StyleProtectedMenuButton from '../style-protected/StyleProtectedMenuButton';
import { omit } from '../../utils/iterables';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledIcon = styled(UIIcon).withConfig({
  displayName: "LineHeightMenu__StyledIcon",
  componentId: "qj1d9u-0"
})(["vertical-align:middle;margin-bottom:2px;"]);
export default class LineHeightMenu extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }
  handleClick({
    currentTarget: {
      value
    }
  }) {
    this.props.onChange(value);
  }
  render() {
    const {
      options,
      lineHeight
    } = this.props;
    const dropdownButtonProps = omit(Object.keys(LineHeightMenu.propTypes), this.props);
    return /*#__PURE__*/_jsx(ToolbarDropdownButton, Object.assign({}, dropdownButtonProps, {
      buttonIconName: "lineHeight",
      menuWidth: 100,
      children: /*#__PURE__*/_jsx(UIList, {
        children: options.map(({
          text: {
            raw
          },
          value
        }) => {
          return /*#__PURE__*/_jsxs(StyleProtectedMenuButton, {
            size: "xs",
            onClick: this.handleClick,
            value: value,
            children: [raw, lineHeight === value && /*#__PURE__*/_jsx(StyledIcon, {
              size: 14,
              name: "success",
              color: EERIE
            })]
          }, value);
        })
      })
    }));
  }
}
LineHeightMenu.propTypes = {
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  lineHeight: PropTypes.number
};